// src/pages/public/LocationIndexPage.tsx
import { useMemo } from 'react';
import PublicSeoPage from './PublicSeoPage';
import { useSeoInventory } from './usePublicSeoData';
import { statesWithInventory } from './publicPageHelpers';
import { getSeoContext } from '../../seo/seoContext';
import { buildLocationIndexModel } from '../../seo/core/pageModels';
import type { PublicPageModel } from '../../seo/types';

/**
 * `/locations` — the national location hub.
 *
 * Lists every state so the hierarchy is complete and crawlable, but only
 * promotes states with real live inventory. The page itself is noindex until at
 * least one state has supply.
 */
function LocationIndexPage() {
  const ctx = getSeoContext();
  const { inventory, loading } = useSeoInventory();

  const model = useMemo<PublicPageModel | null>(
    () =>
      buildLocationIndexModel(
        { states: statesWithInventory(inventory) },
        ctx
      ) as PublicPageModel,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [inventory, ctx.environment, ctx.siteUrl]
  );

  return <PublicSeoPage model={model} loading={loading} />;
}

export default LocationIndexPage;
